// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"470":"31b55ec3","825":"b50ba720"}[chunkId] + ".chunk.css";
};